// extracted by mini-css-extract-plugin
export var container = "_3x-0";
export var icon = "_3x-1";